export class CustomerOrderPaymentDetails {
  amount: number

  receivedDate: string

  constructor(amount: number, receivedDate: string) {
    this.amount = amount
    this.receivedDate = receivedDate
  }
}